import { toast } from "react-toastify";

import {
  fetchApprovedRequestSOStart,
  fetchApprovedRequestSOSuccess,
  fetchApprovedRequestSOFailure,
} from "./reducer";

import { ADMIN_APPROVE_SO_REQUEST } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const approvedRequestSO =
  (jsonObj, orderid, itemId, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchApprovedRequestSOStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        ADMIN_APPROVE_SO_REQUEST(orderid, itemId),
        "PUT",
        jsonObj,
      );

      if (response?.error) {
        dispatch(fetchApprovedRequestSOFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchApprovedRequestSOSuccess(response));
        dispatch(setSuccessMessage(true));
        if (jsonObj?.status === "approved") {
          toast.success("Sales order request approved successfully");
        }
        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (error) {
      dispatch(fetchApprovedRequestSOFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
